// Full-page workspace layout: header, sidebar, main.
//
// The <Outlet /> renders the currently-matched route: either a top-level
// sidebar destination or a per-contact tab route.
import type { ReactNode } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { Header } from './Header.js';
import { Sidebar } from './Sidebar.js';
import { TabStrip } from './TabStrip.js';

export function Layout(): ReactNode {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        fontFamily: 'system-ui, -apple-system, "Segoe UI", sans-serif',
        color: '#111',
        background: '#fff',
      }}
    >
      <Header />
      <div style={{ display: 'flex', flex: 1, minHeight: 0 }}>
        <Sidebar />
        <main style={{ flex: 1, minWidth: 0 }}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}

// The nested layout that adds the 9-tab strip once a contact is in scope.
export function ContactLayout(): ReactNode {
  const params = useParams();
  const contactId = params.contactId || '';
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <TabStrip contactId={contactId} />
      <div style={{ padding: 20, flex: 1, minHeight: 0 }}>
        <Outlet />
      </div>
    </div>
  );
}
